<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-09 14:17:25
 -->
<!--  -->
<template>
  <span>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
      @cell-click="cellClick"
    >
    <!-- 操作按钮扩展 -->
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"

          @click="handleDelete"
        >删 除</el-button>
      </template>
    <!-- 状态栏目扩展  -->
    <template v-slot:status="{row,label}" >
      <el-tag v-if="label === '可用'" type="success">{{label}}</el-tag>
      <el-tag v-else type="info">{{label}}</el-tag>
    </template>

    <!-- 是否允许返回扩展 -->
    <template v-slot:allowReturn="{row}" v-if="allowReturn">
      <el-select v-model="value" multiple placeholder="请选择允许返回的字段">
    <el-option
      v-for="item in row"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
    </el-select>
    </template>

      <!-- 生成密钥扩展 -->
    <template v-slot:GenerateKeyForm="{row}" >
      <el-button :loading="GenerateKeyFormLoading" type="primary" @click="getGenerateKey(row)">生成密钥</el-button>
    </template>
    </avue-crud>
  </span>
</template>

<script>
import { optionConfig } from '@/framework/util/optionConfig'
export default {
  name: 'AppManage',
  props: ['option', 'allowReturn'],
  data() {
    return {
      GenerateKeyFormLoading: false,
      form: {},
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      data: []

    }
  },
  created() {
    this.allowReturn = this.allowReturn ? this.allowReturn : false
  },
  mounted() {
    this.option = optionConfig(this.option)
  },
  methods: {
    cellClick: function(row, column, cell, event) {
      this.$refs.crud.toggleRowSelection(row)
    },
    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    rowSave(row, loading, done) {
      delete row.appKey
      delete row.appSecret
      if (row.allowReturnAttr) {
        let list = row.allowReturnAttr
        var str = ''
        list.forEach(element => {
          str = (str === '' ? '' : str + ',') + element
        })
        row.allowReturnAttr = str
      } else {
        row.allowReturnAttr = ''
      }

      this.$http.post('/app', [row])
        .then(response => {
          this.$message.success('添加应用成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowUpdate(row, index, loading, done) {
      delete row.appKey
      delete row.appSecret
      if (row.allowReturnAttr) {
        let list = row.allowReturnAttr
        var str = ''
        list.forEach(element => {
          str = (str === '' ? '' : str + ',') + element
        })
        row.allowReturnAttr = str
      } else {
        row.allowReturnAttr = ''
      }

      this.$http.put('/app', [row])
        .then(response => {
          this.$message.success('编辑应用成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowDel(row, index) {
      this.deleteRows([row], () => {
        this.data.splice(index, 1)
      })
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        return this.$message.warning('请选择至少一条数据')
      }
      this.deleteRows(this.selectionList, () => {
        this.onLoad()
      })
    },
    deleteRows: function(deleteList, callback) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/app/delete', {}, { params: { appIdList: deleteList.map(item => item.id) }}).then(
          response => {
            this.$message.success('删除成功') && typeof callback === 'function' && callback()
          }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(e => {})
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.oder) {
        orderItemList.push({
          asc: order.oder === 'ascending',
          column: order.prop
        })
      }
      this.loading = true
      this.$http.post('/app/query', { 'entity': params, orderItemList }, { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    getGenerateKey(row) {
      this.GenerateKeyFormLoading = true
      this.$http.get('/app/key-pair').then(response => {
        this.GenerateKeyFormLoading = false
        row.rsaPublicKey = response.data.publicKey
        row.rsaPrivateKey = response.data.privateKey
      }).catch(error => {
        this.GenerateKeyFormLoading = false
        this.$message.error(error.msg || error.message)
      })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
